import * as React from "react";

const Shop = () => {
  return <p class="block py-4 bg-black text-white font-bold tracking-wide lg:text-3xl text-center uppercase">Ricos shop</p>;
};

export default Shop;
